import { useQuery, useMutation } from "@tanstack/react-query";
import clientPortalAxiosInstance from "../../common/utilities/axios/clientPortalAxiosInstance";
import sleep from "sleep-promise";

// get meeting request details by id
export const useGetMeetingRequestByIdQuery = ({ Id }) => {
  return useQuery({
    queryKey: ["getMeetingRequestById", `${Id}`],
    queryFn: () => {
      // sleep(2000);
      return clientPortalAxiosInstance
        .get(`/User-Profile/mymeeting/clientUserMeeting/${Id}`)
        .then((res) => {
          return res.data;
        });
    },
    // The query will not execute until the Id exists
    enabled: !!Id,
  });
};

// get all meeting request status dropdown values
export const useGetMeetingStatusListQuery = () => {
  return useQuery({
    queryKey: ["getMeetingStatusListQuery"],
    queryFn: () => {
      // sleep(2000);
      return clientPortalAxiosInstance
        .get(`/User-Profile/meetingRequest/meetingStatusList`)
        .then((res) => res.data);
    },
  });
};


/**Mutations */
export const useViewMeetingRequestsListMutation = () => {
  return useMutation({
    mutationFn: ({ loggedInUserId, roleId, isEnterpriseAdmin }) => {
      return clientPortalAxiosInstance.post(`/User-Profile/mymeeting/rolebasedAllmeetings`, {
        "LoggedInUserId": loggedInUserId || "",
        "RoleId": roleId || "",
        "IsEnterpriseAdmin": isEnterpriseAdmin
      })
    },
  })
}
// update meeting status and msg
export const useUpdateMeetingRequestIdMutation = () => {
  return useMutation({
    mutationFn: ({ body, Id }) => {
      return clientPortalAxiosInstance.put(
        `/User-Profile/mymeeting/updateMeeting/${Id}`,
        body
      );
    },
  });
};
